"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var body = document.querySelector("body");
    var message = document.createElement("div");
    message.style.top = "".concat(posTop, "px");
    message.style.right = "".concat(posRight, "px");
    message.className = "notification ".concat(type);
    var titl = document.createElement("h2");
    titl.className = "title";
    var desc = document.createElement("p");
    titl.textContent = title;
    desc.textContent = description;
    message.append(titl, desc);
    body.appendChild(message);
    setTimeout(function() {
        return message.hidden = true;
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.37252a21.js.map
